<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex>
                      <h1> Busca de Usuários </h1> {{$store.state.selectedRole.name}}
                    </v-flex>
                    <v-flex>
                       <v-text-field
                        append-icon="search"
                        single-line
                        hide-details
                        v-model="search"
                      ></v-text-field>
                    </v-flex>
                    </v-layout>

                  </v-card-title>
                  <v-card-text>
                      <v-container>
                      <v-layout row> 
                          <v-flex xs-8 v-if="!isMakerlab">
                        <v-data-table
                        :headers="headers"
                        :items="rows"
                        :search="search"
                        :loading="animation"
                        >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                            <td @click="gotoUser(props.item)">
                                <v-avatar :tile="true"
                                size="60">
                                <img class= "img-thumbnail img-search" :id="'logo' + props.item.id" 
                                  :src="props.item.image" @error="imageError(props.item)" />
                                </v-avatar>
                                </td>
                            <td @click="gotoUser(props.item)">{{ props.item.username }}</td>
                            <td @click="gotoUser(props.item)">{{ props.item.email }}</td>
                            <td @click="gotoUser(props.item)">
                              <v-chip label
                              v-for="papel in props.item.groups" :key="papel.index"
                              desable 
                              color='blue'
                              outline>
                                  {{ papel }}
                              </v-chip></td>
                            <td @click="gotoUser(props.item)">{{ props.item.empresa }}</td>
                            <td @click="gotoUser(props.item)">
                              <v-chip label
                              v-for="unidade in props.item.unidade" :key="unidade.index"
                              desable 
                              color='amber'
                              outline>
                                  {{ unidade }}
                              </v-chip></td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não encontrou resultados.
                        </v-alert>
                        <template v-if="mensagem" slot="no-data">
                            Ops... Nenhum dado no momento
                        </template>
                        <template v-if="!mensagem" slot="no-data">
                            Carregando os dados
                        </template>
                        </v-data-table>
                          </v-flex>
                          <!-- MakerLAB -->
                          <v-flex xs-8 v-if="isMakerlab">
                            <v-data-table
                            :headers="headersLab"
                            :items="rows"
                            :search="search"
                            :loading="animation"
                            >
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td @click="gotoUser(props.item)">
                                    <v-avatar :tile="true"
                                    size="60">
                                    <img class= "img-thumbnail img-search" :id="'logo' + props.item.id" 
                                      :src="props.item.image" @error="imageError(props.item)" />
                                    </v-avatar>
                                    </td>
                                <td @click="gotoUser(props.item)">{{ props.item.username }}</td>
                                <td @click="gotoUser(props.item)">{{ props.item.email }}</td>
                                <td @click="gotoUser(props.item)">
                                  <v-chip label
                                  v-for="papel in props.item.groups" :key="papel.index"
                                  desable 
                                  color='blue'
                                  outline>
                                      {{ papel }}
                                  </v-chip></td>
                                <td @click="gotoUser(props.item)">
                                  <v-chip label
                                  v-for="unidade in props.item.unidade" :key="unidade.index"
                                  desable 
                                  color='amber'
                                  outline>
                                      {{ unidade }}
                                  </v-chip></td>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                Sua busca por "{{ search }}" não encontrou resultados.
                            </v-alert>
                            <template v-if="mensagem" slot="no-data">
                                Ops... Nenhum dado no momento
                            </template>
                            <template v-if="!mensagem" slot="no-data">
                                Carregando os dados
                            </template>
                            </v-data-table>
                          </v-flex>

                      </v-layout>
                      </v-container>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
import config from '@/config'

export default {
  data () {
    return {
      search: '',
      animation: true,
      mensagem: false,
      lab: Boolean,
      headersLab: [
        { text: 'Imagem', sortable: false, value: 'image' },
        { text: 'Nome de usuário', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Papel', value: 'groups' },
        { text: 'Unidade', value: 'unidade' }
      ],
      headers: [
        { text: 'Imagem', sortable: false, value: 'image' },
        { text: 'Nome de usuário', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Papel', value: 'groups' },
        { text: 'Empresa', value: 'empresa' },
        { text: 'Unidade', value: 'unidade' }
      ],
      rows: []
    }
  },
  methods: {
    gotoUser (row) {
      this.$router.push(
        {name: 'usuarios-detail',
          params: {'username': row.username}
        })
    },
    imageError (prop) {
      this.onerror = null
      var x = document.getElementById('logo' + prop.id)
      x.src = prop.imagem
    },
    getUser () {
      var pesquisa
      if (this.$store.state.selectedRole.name === 'Admin') {
        pesquisa = '/?groups__name__in=Admin%2CSecretaria%2CMediador%2CCoordenador%2CAluno%2CParente'
      }
      if (this.$store.state.selectedRole.name === 'Secretaria') {
        pesquisa = '/?groups__name__in=Secretaria%2CMediador%2CCoordenador%2CAluno%2CParente'
      }
      if (this.$store.state.selectedRole.name === 'Coordenador') {
        pesquisa = '/?groups__name__in=Mediador%2CCoordenador%2CAluno%2CParente'
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        pesquisa = '/?groups__name__in=Mediador%2CAluno%2CParente'
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        pesquisa = '/?groups__name__in=Mediador%2CAluno%2CParente'
      }
      if (this.$store.state.user.is_superuser) {
        pesquisa = ''
      }
      api.request('GET', 'search-user' + pesquisa).then(response => {
        console.log('entrada', response.data)
        var arr = response.data.map(function (data, index) {
          var image = ''
          if (data.profilePic === null) {
            image = config.imageServerURI + 'images/profilePlaceHolder.jpg'
          } else {
            image = data.profilePic
          }
          return {
            image: image,
            imagem: data.profilePic,
            id: data.id,
            email: data.email,
            name: data.first_name + ' ' + data.last_name,
            last_name: data.last_name,
            url: data.url,
            username: data.username,
            groups: data.groups,
            empresa: data.company,
            unidade: data.unidade
          }
        })
        this.rows = arr
        console.log(arr)
        this.animation = false
        this.mensagem = true
      })
    }
  },
  computed: {
    isMakerlab () {
      this.lab = this.$store.state.company.makerlab
      return this.$store.state.company.makerlab;
    }
  },
  mounted () {
    this.getUser()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/Search.vue